import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import InquiryForm from '../../components/InquiryForm';
import Link from '../../components/Link';
import { buildProductLink } from '../../pages/ProductDetail/ProductDetailPage';
import CountryService from '../../services/CountryService';

interface IInquiryButtonProps extends RouteComponentProps {
  type?: string;
  product: any;
  variant: any;
  redirectToDetail?: boolean;
}

interface IInquiryButtonState {
  modalOpened: boolean;
}

class InquiryButton extends React.Component<IInquiryButtonProps, IInquiryButtonState> {

  constructor(props: IInquiryButtonProps) {
    super(props);

    this.state = {
      modalOpened: false,
    };

    this.onToggleModalOpened = this.onToggleModalOpened.bind(this);
  }

  public componentDidMount() {
    if (this.props && this.props.location && this.props.location.state && this.props.location.state.showInquiry) {
      if (this.props.location.state.showInquiry === true) {
        this.setState({
          modalOpened: true,
        });
      }
    }
  }

  public render(): any {
    const { type, product, variant, redirectToDetail } = this.props;
    const { language } = CountryService.GetInstance();

    if (redirectToDetail) {
      const category = undefined;
      return (
        <Link to={{
          pathname: buildProductLink(product, category, variant, language) as string,
          state: { showInquiry: true }
        }} className={`inquiry-button ${type}`}>
          Contact us
        </Link>
      );
    }

    return (
      <React.Fragment>
        <div className={`inquiry-button ${type}`} onClick={this.onToggleModalOpened}>
          Contact us
        </div>

        {this.state.modalOpened &&
          <InquiryForm 
            product={product}
            variant={variant}
            onClose={this.onToggleModalOpened}
          />}
      </React.Fragment>
    );
  }

  private onToggleModalOpened() {
    this.setState({
      modalOpened: !this.state.modalOpened,
    });
  }
}

export default withRouter(InquiryButton);


// WEBPACK FOOTER //
// ./src/modules/InquiryButton/InquiryButton.tsx